// TODO: Update AU and CA prices with actual region-specific pricing once available

import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { buildStoreConfig } from '../storeAliasHelper';

export const SizingKitProductShopifyMap: Record<
  ShopifyStore,
  Record<string, string | number>
> = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
  ? buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 69,
        variantId: '42144169787462',
        shopifyVariantId: 'gid://shopify/ProductVariant/42144169787462',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/42144169787462:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 1,
        variantId: '42163237027900',
        shopifyVariantId: 'gid://shopify/ProductVariant/42163237027900',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/42163237027900:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 1,
        variantId: '40200422948960',
        shopifyVariantId: 'gid://shopify/ProductVariant/40200422948960',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40200422948960:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 1,
        variantId: '46813981573362',
        shopifyVariantId: 'gid://shopify/ProductVariant/46813981573362',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/46813981573362:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 1,
        variantId: '50364139635006',
        shopifyVariantId: 'gid://shopify/ProductVariant/50364139635006',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/50364139635006:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 1,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 1,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 1,
        // CA inherits variant details from US
      },
      [ShopifyStore.SA]: {
        price: 4,
        // CA inherits variant details from US
      },
      [ShopifyStore.MX]: {
        price: 19,
        // CA inherits variant details from US
      },
      [ShopifyStore.ZA]: {
        price: 49.99,
        // CA inherits variant details from US
      },
      [ShopifyStore.JP]: {
        price: 2000,
      },
    })
  : buildStoreConfig({
      [ShopifyStore.IN]: {
        price: 69,
        variantId: '56102123962441',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102123962441',
        checkoutUrl:
          'https://uhtesting.myshopify.com/cart/56102123962441:1?channel=buy_button',
      },
      [ShopifyStore.ROW]: {
        price: 1,
        variantId: '56102123962441',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102123962441',
        checkoutUrl:
          'https://uhtesting.myshopify.com/cart/56102123962441:1?channel=buy_button',
      },
      [ShopifyStore.US]: {
        price: 1,
        variantId: '56102123962441',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102123962441',
        checkoutUrl:
          'https://uhtesting.myshopify.com/cart/56102123962441:1?channel=buy_button',
      },
      [ShopifyStore.AE]: {
        price: 1,
        variantId: '56102123962441',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102123962441',
        checkoutUrl:
          'https://uhtesting.myshopify.com/cart/56102123962441:1?channel=buy_button',
      },
      [ShopifyStore.EU]: {
        price: 1,
        variantId: '56102123962441',
        shopifyVariantId: 'gid://shopify/ProductVariant/56102123962441',
        checkoutUrl:
          'https://uhtesting.myshopify.com/cart/56102123962441:1?channel=buy_button',
      },
      [ShopifyStore.GB]: {
        price: 1,
        // GB inherits variant details from EU
      },
      [ShopifyStore.AU]: {
        price: 1,
        // AU inherits variant details from EU
      },
      [ShopifyStore.CA]: {
        price: 1,
        // CA inherits variant details from US
      },
      [ShopifyStore.SA]: {
        price: 4,
        // CA inherits variant details from US
      },
      [ShopifyStore.MX]: {
        price: 19,
        // CA inherits variant details from US
      },
      [ShopifyStore.ZA]: {
        price: 19,
        // CA inherits variant details from US
      },
      [ShopifyStore.JP]: {
        price: 2000,
      },
    });
